export enum SlideTypeEnum {
  basicSlide = 'BasicSlide',
  chartSlide = 'ChartSlide',
}
